export interface WidgetEmbedCodeOptions {
  serverUrl: string;
  widgetId?: string;
  primaryColor: string;
  position: string;
  title: string;
  greeting: string;
  otpGreeting: string;
  language: string;
  sessionTimeout: number;
}

export const WIDGET_EVENTS_API_CODE = `// Available events
const widget = document.querySelector('mcp-chat-widget');

widget.addEventListener('mcp-chat:open', () => {});
widget.addEventListener('mcp-chat:close', () => {});
widget.addEventListener('mcp-chat:message-sent', (e) => {
});
widget.addEventListener('mcp-chat:authenticated', (e) => {
});
widget.addEventListener('mcp-chat:error', (e) => {
  console.error(e.detail.error);
  // e.detail.technicalDetail has full error info
});`;

export function formatTokenCount(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(2)}K`;
  return String(value);
}

export function generateWidgetEmbedCode(options: WidgetEmbedCodeOptions): string {
  const attrs: string[] = [];

  if (options.serverUrl) attrs.push(`  server-url="${options.serverUrl}"`);
  if (options.widgetId) attrs.push(`  widget-id="${options.widgetId}"`);

  attrs.push(`  primary-color="${options.primaryColor}"`);
  attrs.push(`  position="${options.position}"`);

  if (options.title) attrs.push(`  title="${options.title}"`);
  if (options.greeting) attrs.push(`  greeting="${options.greeting}"`);
  if (options.otpGreeting) attrs.push(`  otp-greeting="${options.otpGreeting}"`);

  attrs.push(`  language="${options.language}"`);

  if (options.sessionTimeout !== 10) {
    attrs.push(`  session-timeout="${options.sessionTimeout}"`);
  }

  return `<!-- MCP Chat Widget -->\n<script src="https://your-domain.com/widget.js"><\/script>\n\n<mcp-chat-widget\n${attrs.join('\n')}\n></mcp-chat-widget>`;
}
